import styled from 'styled-components';

export const Menu = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .plus-button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #eef7f1;
    color: #2b6a4e;
    border: none;
    flex-shrink: 0;

    i {
      font-size: 20px;
    }

    &:hover {
      background: #e0f0e7;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .menu-popover {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    z-index: 30;
    width: 260px;
    padding: 6px;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 16px;
    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.14);
  }

  .menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 8px 12px;
    border: none;
    background: none;
    border-radius: 12px;
    text-align: left;
    font-size: 14px;
    color: #444;
    cursor: pointer;
    transition: background 0.15s;

    i {
      font-size: 18px;
      color: #6b6b6b;
    }

    .label {
      flex: 1;
    }

    .chevron {
      font-size: 18px;
      color: #a0aec0;
    }

    &:hover {
      background: #eef7f1;
    }

    &.active {
      background: #eef7f1;
      color: #2b6a4e;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        background: none;
      }
    }

    .provider-name {
      display: block;
      font-weight: 600;
    }

    .provider-desc {
      display: block;
      font-size: 11px;
      color: #777;
    }

    .badge-on {
      margin-left: auto;
      background: #2b6a4e;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      padding: 2px 8px;
      border-radius: 999px;
    }
  }

  .divider {
    height: 1px;
    background: #eee;
    margin: 4px 0;
  }

  .submenu-wrapper {
    position: relative;
  }

  .submenu-popover {
    position: absolute;
    left: 100%;
    top: 0;
    width: 220px;
    padding: 6px;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 16px;
    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.14);
  }
`;
